import React, { useState } from 'react';

import { Form, Switch, Typography, Row, Col, Space } from 'antd';
import { getTranslatedString } from 'helpers/i18n';

const { Text } = Typography;

const IncomeFormField = ({ locale, name, availableOptions = [], allOptions = [] }) => {
  const form = Form.useFormInstance();
  const [allOptionsList, setAllOptionsList] = useState(
    allOptions.map((option) => ({ value: option, checked: availableOptions.includes(option) }))
  );

  const handleChange = (checked, index) => {
    const newOtions = [...allOptionsList];
    newOtions[index] = { ...newOtions[index], checked };
    setAllOptionsList(newOtions);
    form.setFields([
      {
        name: ['fields', name, 'translations', locale, 'available_options'],
        value: newOtions.flatMap((option) => (option.checked ? [option.value] : [])),
      },
    ]);
  };

  return (
    <Form.Item noStyle name={[name, 'translations', locale, 'available_options']}>
      <Text style={{ display: 'block', marginBottom: 24 }}>
        {getTranslatedString(
          'landlordPortal.applicationTemplate.prototypesDrawer.form.supportingDocumentation'
        )}
      </Text>

      {allOptionsList.map((option, index) => (
        <Row key={index}>
          <Col span={4}>
            <Form.Item>
              <Switch
                checked={option.checked}
                onChange={(checked) => handleChange(checked, index)}
              />
            </Form.Item>
          </Col>

          <Col span={20}>{option.value}</Col>
        </Row>
      ))}
    </Form.Item>
  );
};

export default IncomeFormField;
